$(document).ready(function () {
  Sceon.Escorts = {};

  Sceon.Escorts.url =
    window.location.pathname !== '/' ? window.location.pathname : '/escorts';

  Sceon.Escorts.Load = function (url, data, isScrolling, isFirstLoad) {
    let f_overlay = null;
    let esc_overlay = null;

    if ($('#and6-filters').length) {
      f_overlay = new Sceon.Overlay($('#and6-filters .filter-container'), {
        loader: '/imgr/loader-tiny.gif',
        offset: { bottom: 0, top: 0 },
      });
      isScrolling ? f_overlay.disable() : f_overlay.enable();
    }

    if ($('.ajax-container').length) {
      esc_overlay = new Sceon.Overlay($('.ajax-container'), {
        loader: '/imgr/loader-tiny.gif',
        offset: { bottom: 0, top: 0 },
      });
      isScrolling ? esc_overlay.disable() : esc_overlay.enable();
    }

    $.ajax({
      url:
        Sceon.Escorts.url +
        `?ajax${isScrolling || isFirstLoad ? `&is_scroll=${1}` : ''}`,
      method: 'POST',
      data: data,
      success: function (resp) {
        if (isScrolling) {
          Sceon.Scroll.onSuccess(resp);
        } else {
          if (typeof resp == 'object') {
            $('.ajax-container').replaceWith(resp.escortList);
            $('#and6-filters').html(resp.filterBody);
          } else {
            $('.ajax-container').replaceWith(resp);
          }

          if ($('#and6-filters').length) {
            Sceon.Filter.init();
            Sceon.LocationHash.setCheckboxesFromHash();
          }
          Sceon.HashController.init();
          Sceon.PhotoRoller.init();
          let hash = location.hash.substring(1);
          Sceon.Escorts.onPrClick(hash);
        }

        f_overlay?.disable();
        esc_overlay?.disable();
      },
      error: function (error) {
        if (isScrolling) {
          Sceon.Scroll.onError(error);
        } else {
          if ($('.search-by-name')?.val()?.length > 50) {
            $('.search-by-name').val('');
            Sceon.LocationHash.Set(Sceon.LocationHash.Make());
          }
        }

        f_overlay?.disable();
        esc_overlay?.disable();
      },
    });
  };

  Sceon.Escorts.onPrClick = function (hash) {
    let from;
    if (location.pathname.includes('escorts')) {
      from = location.pathname.substring(9);
    } else {
      from = location.pathname;
    }

    if (from.length > 0) {
      if (from.startsWith('sex-')) {
        from = `independent/${from}`;
      }

      hash = `${hash}from=${from}`;
      if (from.includes('nuove')) {
        hash = `from=nuove`;
      }
    } else {
      hash = `${hash}from=independent`;
    }

    $(document)
      .unbind('click auxclick')
      .on(
        'click auxclick',
        '.escort-item .escort-link, .escort-item .view_sedcard',
        function () {
          event.preventDefault();
          let href = $(this).attr('href');
          if (event.type == 'click') {
            location.href = `${href}?#${hash}`;
          } else if (event.type == 'auxclick' && event.which !== 3) {
            window.open(`${href}?#${hash}`);
          }
        },
      );
  };

  if (
    location.pathname.includes('nuove') ||
    location.pathname.includes('videos')
  ) {
    setTimeout(() => {
      Sceon.Escorts.onPrClick('');
    }, 0);
  }

  window.addEventListener('click', (event) => {
    let parent = event.target.closest('.escort-item');
    if (parent) {
      window.scrollTo(0, window.scrollY);
      sessionStorage.setItem('scrollPosition', window.scrollY);
    }
  });
});

window.addEventListener('load', () => {
  const scrollPosition = sessionStorage.getItem('scrollPosition');

  if (scrollPosition) {
    const contentLoadingCheck = setInterval(() => {
      if (document.body.scrollHeight > scrollPosition) {
        clearInterval(contentLoadingCheck);
        window.scrollTo(0, scrollPosition);
        sessionStorage.removeItem('scrollPosition');
      }
    }, 100);

    setTimeout(() => clearInterval(contentLoadingCheck), 2000);
  }
});
